import React, { Component } from "react";
import AsyncSelect from "react-select/async";

import { Form, Button, Checkbox, Radio } from "semantic-ui-react";
import isEmpty from "validator/lib/isEmpty";
import isEmail from "validator/lib/isEmail";
import equals from "validator/lib/equals";
import matches from "validator/lib/matches";
import contains from "validator/lib/contains";
import isLength from "validator/lib/isLength";
import InlineError from "../messages/InlineError";

import { connect } from "react-redux";

import { getCitiesList } from "../../actions/citiesActions";

class EditPractitionerForm extends Component {
  state = {
    data: {
      practitioner_id: "",
      names: "",
      lastname1: "",
      lastname2: "",
      email_address: "",
      medical_record: "",
      specialty: "",
      city: "",
      birthdate:"",
      gender:"",
      phone: "",
      username: "",
      password_digest: "",
      passr:""
    },
    isLoading: true,
    errors: {},
  };

  onChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  async getOptionsForCities(input) {
      if (input.length > 3) {
        await this.props.getCitiesList(input);
        const citiesOptions = this.props.ciudades.map((city, index) => ({
          label: city.city + ", " + city.state,
          value: city.code,
          ...city,
        }));
        return citiesOptions;
      } else {
        return [];
      }
    }
  
  handleChangeCity = (item) => {
      this.setState({ data: { ...this.state.data, city: item.value } });
  };

  validate = (data) => {
    const errors = {};

    if (isEmpty(data.names)) errors.names = "No puede estar en blanco.";

    if (isEmpty(data.practitioner_id)) errors.practitioner_id = "No puede estar en blanco.";

    if (isEmpty(data.lastname1)) errors.lastname1 = "No puede estar en blanco.";

    if (isEmpty(data.lastname2)) errors.lastname2 = "No puede estar en blanco.";

    if (!isEmail(data.email_address)) errors.email_address = "No es un correo válido.";

    if (isEmpty(data.gender)) errors.gender = "Debe elegir uno de los dos.";

    if (isEmpty(data.birthdate)) errors.birthdate = "No puede estar en blanco.";

    if (isEmpty(data.city)) errors.city = "No puede estar en blanco.";

    if (isEmpty(data.username)) errors.username = "No puede estar en blanco.";

    if (!matches(data.username, /^[a-z0-9\-_.]+$/i)) {
          errors.username =
            "El nombre de usuario solo puede contener letras, números o los caracteres guión ( - ), guión bajo ( _ ) o punto ( . )";
        }
    if (contains(data.password_digest, " ")) {
          errors.password_digest = "La contraseña no debe contener espacios";
        }
    
    if (!isLength(data.password_digest, { min: 8, max: 30 })) {
          errors.password_digest = "La contraseña debe contener de 8 a 30 caracteres";
        } else {
        if (
            !matches(
              data.password_digest,
              /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?['\/~`!@#$%^&*()_\-+={}[]|;:"<>,.?\\]).{12,30}$/g
            )
          ) {
            errors.password_digest = `La contraseña debe estar compuesta por al menos 1 mayúscula, 1 minúscula, 4 números y 1 caracter especial`;
          }
        }
      if (isEmpty(data.passr))
            errors.passr = "No puede estar en blanco.";
      
          if (!equals(data.password_digest, data.passr)) {
            errors.passr = "Las contraseñas no son iguales";
          }
    return errors;
  };

  onSubmit = async (e) => {
    e.preventDefault();
    const errors = this.validate(this.state.data);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      this.props.submitPractitioner(this.state.data);
    }
  };

  _onChangeCheckbox = (e, data) => {
    const checked = data.checked ? 1 : 0;
    this.setState({
      data: { ...this.state.data, [data.names]: checked },
    });
  };
  _onChangeRadioButton = (e, data) => {
    this.setState({ data: { ...this.state.data, gender: data.value } });
  };

  /*componentDidMount() {
    //Pre llenado del formulario
    this.props.getCitiesList();
    this.setState({
      isLoading: false,
      data: {
        ...this.state.data, 
        practitioner_id: this.props.practitioner_id || "",
        names: this.props.names || "",
        lastname1: this.props.lastname1 || "",
        lastname2:this.props.lastname2 || "",
        medical_record:this.props.medical_record || "",
        email_address: this.props.email_address || "",
        specialty:this.props.specialty || "",
        city:this.props.city || "",
        medical_record:this.props.medical_record || "",
        gender:this.props.gender || "",
        nacimiento : this.props.birthdate,
        phone: this.props.phone || "",
        username: this.props.username || "",
        password_digest : this.props.password_digest || ""
      },
    });
  }*/

  componentDidUpdate(prevProps) {
    if (this.props.practitioner_id !== prevProps.practitioner_id) {
      this.setState({
        isLoading: false,
        data: {
          ...this.state.data,
          practitioner_id: this.props.practitioner_id,
        },
      });
    }
  }

  onChangeCheckbox = (e, checkbox) => {
    const checked = checkbox.checked === true ? 1 : 0;
    this.setState({
      data: { ...this.state.data, approved: checked },
    });
  };

  render() {
    const { errors, data } = this.state;

    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; //January is 0!
    let yyyy = today.getFullYear();
    let y_18 = yyyy - 18;
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }

    let maxDate = y_18 + "-" + mm + "-" + dd;

    return (
      <Form onSubmit={this.onSubmit}>
        <Form.Group widths="equal">
          <Form.Field error={!!errors.practitioner_id}>
            <label htmlFor="practitioner_id">Numero Identificación *</label>
            <input
              className="u-full-width"
              type="text"
              placeholder="Escriba su documento de identidad"
              id="practitioner_id"
              name="practitioner_id"
              disabled={this.props.role === 1 ? false : true}
              onChange={this.onChange}
              value={data.practitioner_id}
            />
            {errors.practitioner_id && <InlineError text={errors.practitioner_id} />}
          </Form.Field>
          <Form.Field error={!!errors.names}>
            <label htmlFor="names">Nombre Completo *</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="names"
              name="names"
              disabled={this.props.role === 1 ? false : true}
              onChange={this.onChange}
              value={data.names}
            />
            {errors.names && <InlineError text={errors.names} />}
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          
          <Form.Field error={!!errors.lastname1}>
            <label htmlFor="lastname1">Primer Apellido *</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="lastname1"
              name="lastname1"
              disabled={this.props.role === 1 ? false : true}
              onChange={this.onChange}
              value={data.lastname1}
            />
            {errors.lastname1 && <InlineError text={errors.lastname1} />}
          </Form.Field>
          <Form.Field error={!!errors.lastname2}>
            <label htmlFor="lastname2">Segundo Apellido *</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="lastname2"
              name="lastname2"
              disabled={this.props.role === 1 ? false : true}
              onChange={this.onChange}
              value={data.lastname2}
            />
            {errors.lastname2 && <InlineError text={errors.lastname2} />}
          </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
          <Form.Field error={!!errors.birthdate}>
            <label htmlFor="birthdate">Fecha Nacimiento *</label>
            <input
              className="u-full-width"
              type="date"
              placeholder=""
              id="birthdate"
              name="birthdate"
              min={"1920-01-01"}
              max={maxDate}
              disabled={this.props.role === 1 ? false : true}
              onChange={this.onChange}
              value={data.birthdate}
            />
            {errors.birthdate && <InlineError text={errors.birthdate} />}
          </Form.Field>
          <Form.Field error={!!errors.gender}>
          <label htmlFor="gender">Género *</label>
            <Form.Group inline>
                <Form.Field
                    control={Radio}
                    label="Femenino"
                    name="genero"
                    value="0"
                    checked={data.gender === "0"}
                    onChange={this._onChangeRadioButton}
                  />
                  <Form.Field
                    control={Radio}
                    label="Masculino"
                    name="genero"
                    value="1"
                    checked={data.gender === "1"}
                    onChange={this._onChangeRadioButton}
                    />
              </Form.Group>
            {errors.gender && <InlineError text={errors.gender} />}
          </Form.Field>
          <Form.Field error={!!errors.city}>
            <label htmlFor="city">Ciudad *</label>
            <AsyncSelect
              isClearable
              // defaultInputValue={defaultCity}
              // isDisabled={values.PaisDeProcedencia !== "170"}
              name="city"
              placeholder="Escriba el nombre de la ciudad"
              onChange={this.handleChangeCity}
              loadOptions={(e) => this.getOptionsForCities(e)}
            />
            {errors.city && <InlineError text={errors.city} />}
          </Form.Field>
          
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Field error={!!errors.specialty}>
            <label htmlFor="specialty">Especialidad</label>
            <input
              className="u-full-width"
              type="text"
              placeholder="Medico o Enfermero"
              id="specialty"
              name="specialty"
              onChange={this.onChange}
              value={data.specialty}
            />
            {errors.specialty && <InlineError text={errors.specialty} />}
          </Form.Field>
          <Form.Field error={!!errors.medical_record}>
            <label htmlFor="medical_record">Registro Médico</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="medical_record"
              name="medical_record"
              disabled={this.props.role === 1 ? false : true}
              onChange={this.onChange}
              value={data.medical_record}
            />
            {errors.medical_record && <InlineError text={errors.medical_record} />}
          </Form.Field> 
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Field error={!!errors.email_address}>
            <label htmlFor="email_address">Correo Electrónico *</label>
            <input
              className="u-full-width"
              type="email"
              placeholder="Correo corporativo"
              id="email_address_address"
              name="email_address"
              disabled={this.props.role === 1 ? false : true}
              onChange={this.onChange}
              value={data.email_address}
            />
            {errors.email_address && <InlineError text={errors.email_address} />}
          </Form.Field>
          <Form.Field error={!!errors.phone}>
            <label htmlFor="phone">Celular</label>
            <input
              className="u-full-width"
              type="text"
              placeholder="Teléfono fijo o celular"
              id="phone"
              name="phone"
              onChange={this.onChange}
              value={data.phone}
            />
            {errors.phone && <InlineError text={errors.phone} />}
          </Form.Field>
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Field error={!!errors.username}>
            <label htmlFor="username">Usuario *</label>
            <input
              className="u-full-width"
              type="text"
              placeholder="Usuario HIS"
              id="username"
              name="username"
              onChange={this.onChange}
              value={data.username}
            />
            {errors.username && <InlineError text={errors.username} />}
           </Form.Field>
           <Form.Field error={!!errors.password_digest}>
            <label htmlFor="password_digest">Contraseña *</label>
            <input
              className="u-full-width"
              type="password"
              placeholder=""
              id="password_digest"
              name="password_digest"
              onChange={this.onChange}
              value={data.password_digest}
            />
            {errors.password_digest && <InlineError text={errors.password_digest} />}
           </Form.Field>
           <Form.Field error={!!errors.passr}>
            <label htmlFor="passr">Confirmar Contraseña *</label>
            <input
              className="u-full-width"
              type="password"
              placeholder=""
              id="passr"
              name="passr"
              onChange={this.onChange}
              value={data.passr}
            />
            {errors.passr && <InlineError text={errors.passr} />}
           </Form.Field>
          </Form.Group>
        {this.props.practitioner_id === this.props.loggedPractitioner ? (
          <div>
            <Form.Field>
              <label>Tratamiento de datos personales</label>
            </Form.Field>
          </div>
        ) : null}

        <Form.Field className="buttonRight">
          <Button
            content="Cancelar"
            type="button"
            onClick={() => this.props.cancel()}
          ></Button>
          <Button
            color="blue"
            content="Guardar"
            icon="save"
            labelPosition="right"
          />
        </Form.Field>
      </Form>
    );
  }
}
const mapStateToProps = (state) => {
  const { cities } = state;
  const { role } = state.practitioner.resp;

    // sin información del medico, solo la cédula que ingresó
    return {
      practitioner_id: "",
      names: "",
      lastname1: "",
      lastname2: "",
      email_address: "",
      medical_record: "",
      specialty: "",
      city: "",
      ciudades : cities.cities,
      practitioner_id:"",
      username: "",
      password_digest: "",
      role
    };
  }

export default connect(mapStateToProps,{ getCitiesList })(EditPractitionerForm);
